module.exports = __webpack_public_path__ + "static/media/Goat-web-logo.ed9fbf03.png";